$(function () {
    if ($('.js-player-sided').length > 0) {
        const playersSided = Plyr.setup('.js-player-sided', {
            controls: ['play', 'play-large', 'mute'], // hide UI
            muted: true,
            autoplay: false
        });
        // Force mute state on both Plyr and the media element
        playersSided.forEach(player => {
            // These ensure browser and Plyr stay in sync on load
            player.muted = true;
            player.media.muted = true;
        });
    
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.6 // Adjust how much of the element is visible before playing
        };
    
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const video = entry.target;
                const player = playersSided.find(p => p.media === video);
    
                if (entry.isIntersecting) {
                    player.play();
                } else {
                    player.pause();
                }
            });
        }, observerOptions);
    
        document.querySelectorAll('.js-player-sided').forEach(video => {
            observer.observe(video);
        });
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/video-split.js